// Client entry. Hydrates server-rendered markup when present, otherwise mounts.
// Keep options in sync with ssr/ssr.ts.
import { createInertiaApp } from '@inertiajs/svelte'
import { initAnalytics } from '@/lib/analytics'

// Per-request CSP nonce from Rails (csp_meta_tag). Inertia applies it to the
// <style> tag it injects for its error dialog.
const nonce = document.querySelector<HTMLMetaElement>('meta[name="csp-nonce"]')?.content

createInertiaApp({
  pages: '../pages',
  serverHead: true,
  nonce,
  progress: false,

  defaults: {
    form: {
      forceIndicesArrayFormatInFormData: false,
      withAllErrors: true,
    },
    visitOptions: () => {
      return { queryStringArrayFormat: 'brackets' }
    },
  },
})

initAnalytics()
